import util from './util'

let Publications = Vue.component('publications', {
	props: ['jakob', 'cilla', 'jonas', 'jesper', 'all'],
	mounted() {
		for (let i = 0; i < this.cilla.internal.length; i++) {
			let id = this.cilla.internal[i].ID
			util.getPermalinkFromID(id).then((link) => {
				Vue.set(this.cilla.internal[i], 'permalink', JSON.parse(link))
			})
			util.getMultilineTitleFromID(id).then((title) => {
				Vue.set(this.cilla.internal[i], 'post_title', JSON.parse(title))
			})
		}
		for (let i = 0; i < this.jakob.internal.length; i++) {
			let id = this.jakob.internal[i].ID
			util.getPermalinkFromID(id).then((link) => {
				Vue.set(this.jakob.internal[i], 'permalink', JSON.parse(link))
			})
			util.getMultilineTitleFromID(id).then((title) => {
				Vue.set(this.jakob.internal[i], 'post_title', JSON.parse(title))
			})
		}
		for (let i = 0; i < this.jonas.internal.length; i++) {
			let id = this.jonas.internal[i].ID
			util.getPermalinkFromID(id).then((link) => {
				Vue.set(this.jonas.internal[i], 'permalink', JSON.parse(link))
			})
			util.getMultilineTitleFromID(id).then((title) => {
				Vue.set(this.jonas.internal[i], 'post_title', JSON.parse(title))
			})
		}
		for (let i = 0; i < this.jesper.internal.length; i++) {
			let id = this.jesper.internal[i].ID
			util.getPermalinkFromID(id).then((link) => {
				Vue.set(this.jesper.internal[i], 'permalink', JSON.parse(link))
			})
			util.getMultilineTitleFromID(id).then((title) => {
				Vue.set(this.jesper.internal[i], 'post_title', JSON.parse(title))
			})
		}
		if (this.all) {
			for (let i = 0; i < this.all.internal.length; i++) {
				let id = this.all.internal[i].ID
				util.getPermalinkFromID(id).then((link) => {
					Vue.set(this.all.internal[i], 'permalink', JSON.parse(link))
				})
				util.getMultilineTitleFromID(id).then((title) => {
					Vue.set(this.all.internal[i], 'post_title', JSON.parse(title))
				})
			}
		}

	},
	template: `
		<div class="h1-container">
			<span class="post-list-label thematic-break">Jesper Olsson</span>
			<ul class="post-list">
				<li v-for="(post, index) in jesper.internal">
					<colored-link :type="post.post_type" :href="post.permalink" :data-id="post.ID" v-html="post.post_title"></colored-link>
				</li>
				<li v-for="(post, index) in jesper.external">
					<a :href="post.url || null" :data-cursor="post.url ? 'external' : 'dead'" target="_blank" v-html="post.headline"></a>
				</li>
			</ul>
			<span class="post-list-label thematic-break">Jonas Ingvarsson</span>
			<ul class="post-list">
				<li v-for="(post, index) in jonas.internal">
					<colored-link :type="post.post_type" :href="post.permalink" :data-id="post.ID" v-html="post.post_title"></colored-link>
				</li>
				<li v-for="(post, index) in jonas.external">
					<a :href="post.url || null" :data-cursor="post.url ? 'external' : 'dead'" target="_blank" v-html="post.headline"></a>
				</li>
			</ul>
			<span class="post-list-label thematic-break">Jakob Lien</span>
			<ul class="post-list">
				<li v-for="(post, index) in jakob.internal">
					<colored-link :type="post.post_type" :href="post.permalink" :data-id="post.ID" v-html="post.post_title"></colored-link>
				</li>
				<li v-for="(post, index) in jakob.external">
					<a :href="post.url || null" :data-cursor="post.url ? 'external' : 'dead'" target="_blank" v-html="post.headline"></a>
				</li>
			</ul>
			<span class="post-list-label thematic-break" v-if="all">Rep/Rec/Digit</span>
			<ul class="post-list" v-if="all">
				<li v-for="(post, index) in all.internal">
					<colored-link :type="post.post_type" :href="post.permalink" :data-id="post.ID" v-html="post.post_title"></colored-link>
				</li>
				<li v-for="(post, index) in all.external">
					<a :href="post.url || null" :data-cursor="post.url ? 'external' : 'dead'" target="_blank" v-html="post.headline"></a>
				</li>
			</ul>
			<span class="post-list-label thematic-break">Cecilia Lindhé</span>
			<ul class="post-list">
				<li v-for="(post, index) in cilla.internal">
					<colored-link :type="post.post_type" :href="post.permalink" :data-id="post.ID" v-html="post.post_title"></colored-link>
				</li>
				<li v-for="(post, index) in cilla.external">
					<a :href="post.url || null" :data-cursor="post.url ? 'external' : 'dead'" target="_blank" v-html="post.headline"></a>
				</li>
			</ul>
		</div>`
});

export default Publications
